/**
 * Breaks circular dependency: store <-> motion-components.
 * App sets the getter; motion-components reads it.
 */
let getTableStore: () => any = () => undefined;
let getMotionUIStore: () => any = () => undefined;

export function setTableStoreGetter(fn: () => any) {
  getTableStore = fn;
}

export function getTableStoreFromRef() {
  return getTableStore();
}

export function setMotionUIStoreGetter(fn: () => any) {
  getMotionUIStore = fn;
}

export function getMotionUIStoreFromRef() {
  return getMotionUIStore();
}
